import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["plan", "ctaText", "onSelect", "disableButton", "type", "onProviderDashboard", "noShadow", "isPreview", "planWaitlistIds"];
import classNames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import { Button, Icon } from '../../subkit-ui';
import { getCurrentSubscriptionFromPlan, getCurrentSubscriptionFromService, sortObjectArrayByAttribute } from '../../utils/helpers';
import { Modal } from '../Modal';
import { PriceComponent, ReferralDiscountPill } from './shared';
import { SubscriptionPlanDescription } from './SubscriptionPlanDescription';
import style from './TWSubscriptionPlan.module.sass';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var TWSubscriptionPlanCardType;

(function (TWSubscriptionPlanCardType) {
  TWSubscriptionPlanCardType["FULL_WIDTH"] = "full-width";
  TWSubscriptionPlanCardType["SKINNY"] = "skinny";
})(TWSubscriptionPlanCardType || (TWSubscriptionPlanCardType = {}));

export var TWSubscriptionPlan = function TWSubscriptionPlan(_ref) {
  var _plan$providerService, _props$user, _plan$features;

  var plan = _ref.plan,
      ctaText = _ref.ctaText,
      onSelect = _ref.onSelect,
      disableButton = _ref.disableButton,
      type = _ref.type,
      onProviderDashboard = _ref.onProviderDashboard,
      noShadow = _ref.noShadow,
      isPreview = _ref.isPreview,
      planWaitlistIds = _ref.planWaitlistIds,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      showModal = _useState[0],
      setModalActual = _useState[1];

  var setModal = props.setModal || setModalActual; // is the user subscribed to THIS plan?

  var isCurrent = getCurrentSubscriptionFromPlan(props.userSubscriptions, plan.id) !== undefined; // is the user subscribed to ANY plan of this plan's service?

  var subscribedToService = !!getCurrentSubscriptionFromService(props.userSubscriptions, (_plan$providerService = plan.providerService) === null || _plan$providerService === void 0 ? void 0 : _plan$providerService.id); // is the user a PlanProspect (on the waitlist) of this plan?

  var userIsPlanProspect = // from UserServiceRelationship (ie. existed already on server at initial load)
  planWaitlistIds && planWaitlistIds.includes(plan.id) || ((_props$user = props.user) === null || _props$user === void 0 ? void 0 : _props$user.email) && props.planProspects.filter(function (p) {
    return p.email === props.user.email && p['planId'] === plan.id;
  }).length > 0;
  var interval = (plan === null || plan === void 0 ? void 0 : plan.interval_count) > 1 ? "".concat(plan === null || plan === void 0 ? void 0 : plan.interval_count, " ").concat(plan === null || plan === void 0 ? void 0 : plan.interval, "s") : "".concat(plan === null || plan === void 0 ? void 0 : plan.interval);
  var sortedFeatures = plan !== null && plan !== void 0 && (_plan$features = plan.features) !== null && _plan$features !== void 0 && _plan$features.length ? sortObjectArrayByAttribute(plan.features, 'order', false, 'asc') : null;
  var buttonText = 'Subscribed';

  if (!isCurrent) {
    if (props.loading) buttonText = 'Please wait...';else if (!(plan !== null && plan !== void 0 && plan.waitlist) && subscribedToService) buttonText = 'Change Plan';else if (plan !== null && plan !== void 0 && plan.waitlist && userIsPlanProspect) buttonText = 'On the Waitlist';else if (plan !== null && plan !== void 0 && plan.waitlist) buttonText = 'Join Waitlist';else if ((plan === null || plan === void 0 ? void 0 : plan.trial_period_days) > 0) buttonText = 'Try it Free';else buttonText = ctaText;
  }

  var canShowDiscount = !onProviderDashboard;

  var handleSubscribe = function handleSubscribe(event) {
    event.preventDefault();
    setModal(false);
    onSelect && onSelect(plan);
  };

  var onLearnMoreClick = function onLearnMoreClick() {
    setModal(true);
  };

  var handleSetModal = function handleSetModal(_ref2) {
    var show = _ref2.show;
    setModal(show);
  };

  var subscribeButtonDisabled = props.loading || isCurrent || (plan === null || plan === void 0 ? void 0 : plan.waitlist) && userIsPlanProspect || disableButton;

  var PriceAndButton = /*#__PURE__*/_jsxs("div", {
    className: "w-full",
    children: [/*#__PURE__*/_jsx(PriceComponent, {
      plan: plan,
      subscribedToService: subscribedToService,
      interval: interval,
      type: type,
      canShowDiscount: canShowDiscount
    }), !subscribedToService && !plan.waitlist && canShowDiscount && plan.invoicePreview && plan.invoicePreview.lines.length > 1 && plan.invoicePreview.lines.filter(function (l) {
      return l.amount < 0;
    }).length > 0 && /*#__PURE__*/_jsx("div", {
      className: classNames('flex justify-center', {
        'mt-4': type === TWSubscriptionPlanCardType.FULL_WIDTH,
        'mt-6': type === TWSubscriptionPlanCardType.SKINNY
      }),
      children: /*#__PURE__*/_jsx(ReferralDiscountPill, {
        plan: plan
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classNames({
        'mt-6 md:mt-8': !plan.waitlist || type === TWSubscriptionPlanCardType.SKINNY
      }),
      children: /*#__PURE__*/_jsx("div", {
        className: "rounded-md shadow",
        children: /*#__PURE__*/_jsx(Button, {
          text: buttonText,
          size: "lg",
          disabled: subscribeButtonDisabled,
          onClick: handleSubscribe,
          "data-cy": "subscribe-".concat(plan.name)
        })
      })
    })]
  });

  var renderFeature = function renderFeature(ftr) {
    return /*#__PURE__*/_jsxs("div", {
      role: "listitem",
      className: style.feature,
      children: [/*#__PURE__*/_jsx("div", {
        className: style.featureIconContainer,
        children: /*#__PURE__*/_jsx(Icon, {
          name: "check-circle",
          type: "solid",
          className: style.featureIcon
        })
      }), /*#__PURE__*/_jsx("p", {
        className: classNames('m-0 ml-3 text-base text-gray-900 leading-6', {
          'line-clamp-5': type === TWSubscriptionPlanCardType.SKINNY
        }),
        children: ftr.name
      })]
    }, ftr.id || ftr.name);
  };

  var renderFeatures = function renderFeatures() {
    var evenSortedFeatures = sortedFeatures === null || sortedFeatures === void 0 ? void 0 : sortedFeatures.filter(function (_f, index) {
      return index % 2 === 0;
    });
    var oddSortedFeatures = sortedFeatures === null || sortedFeatures === void 0 ? void 0 : sortedFeatures.filter(function (_f, index) {
      return index % 2 === 1;
    });
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "mt-6",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center mb-6",
          children: [/*#__PURE__*/_jsx("h4", {
            className: "m-0 flex-shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-gray-900",
            children: "What's included"
          }), type === TWSubscriptionPlanCardType.FULL_WIDTH && /*#__PURE__*/_jsx("div", {
            className: "flex-1 border border-l-0 border-r-0 border-b-0 border-t-2 border-gray-200"
          })]
        }), type === TWSubscriptionPlanCardType.FULL_WIDTH && /*#__PURE__*/_jsxs("div", {
          role: "list",
          className: "mt-3 mb-0 grid gap-x-8 grid-cols-2",
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex-1",
            children: sortedFeatures && (evenSortedFeatures === null || evenSortedFeatures === void 0 ? void 0 : evenSortedFeatures.map(function (ftr) {
              return renderFeature(ftr);
            }))
          }), /*#__PURE__*/_jsx("div", {
            className: "flex-1",
            children: sortedFeatures && (oddSortedFeatures === null || oddSortedFeatures === void 0 ? void 0 : oddSortedFeatures.map(function (ftr) {
              return renderFeature(ftr);
            }))
          })]
        }), !noShadow && type === TWSubscriptionPlanCardType.SKINNY && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            role: "list",
            className: "mt-3 mb-0 grid gap-x-8 grid-cols-1",
            children: sortedFeatures && sortedFeatures.slice(0, 3).map(function (ftr) {
              return renderFeature(ftr);
            })
          }), (sortedFeatures === null || sortedFeatures === void 0 ? void 0 : sortedFeatures.length) > 3 && /*#__PURE__*/_jsx("div", {
            className: "mt-6",
            children: /*#__PURE__*/_jsx("a", {
              className: "clickable fw-500 text-subkit-primary",
              onClick: onLearnMoreClick,
              children: "See more"
            })
          })]
        }), noShadow && type === TWSubscriptionPlanCardType.SKINNY && sortedFeatures.map(function (ftr) {
          return renderFeature(ftr);
        })]
      })
    });
  };

  var TrialText = /*#__PURE__*/_jsxs(_Fragment, {
    children: ["Try ", plan.trial_period_days, " days free, then billed ", plan.interval, "ly. Cancel anytime."]
  });

  var deviceInfo = useDeviceInfo();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!props.setModal && /*#__PURE__*/_jsx(Modal, {
      classes: style.modal,
      showCloseIcon: !!deviceInfo.mobile || !!deviceInfo.tablet,
      showModal: showModal,
      setModal: handleSetModal,
      children: /*#__PURE__*/_jsx(TWSubscriptionPlan, {
        plan: plan,
        onSelect: onSelect,
        type: deviceInfo.mobile || deviceInfo.tablet ? TWSubscriptionPlanCardType.SKINNY : TWSubscriptionPlanCardType.FULL_WIDTH,
        noShadow: true,
        setModal: setModal,
        planWaitlistIds: planWaitlistIds,
        disableButton: subscribeButtonDisabled
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames('bg-white rounded-lg test-plan-tab', {
        'shadow-card': !noShadow,
        'h-auto': isPreview,
        'h-full': type === TWSubscriptionPlanCardType.SKINNY && !isPreview,
        'min-h-card-horizontal': type === TWSubscriptionPlanCardType.FULL_WIDTH,
        flex: type === TWSubscriptionPlanCardType.FULL_WIDTH
      }),
      "data-cy": plan.name,
      children: [/*#__PURE__*/_jsxs("div", {
        className: classNames('', {
          'py-8 px-6': type === TWSubscriptionPlanCardType.SKINNY,
          'p-12 flex-1': type === TWSubscriptionPlanCardType.FULL_WIDTH
        }),
        children: [/*#__PURE__*/_jsx("div", {
          className: "",
          children: /*#__PURE__*/_jsx("h2", {
            className: "m-0 text-gray-900",
            children: plan.name
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classNames('mt-4 text-gray-900 leading-6', {
            'h-24 min-h-24': !isPreview && type === TWSubscriptionPlanCardType.SKINNY && !noShadow,
            'h-auto min-h-6': isPreview
          }),
          children: /*#__PURE__*/_jsx(SubscriptionPlanDescription, {
            description: plan.description,
            numberOfLines: noShadow && 'none' || type === TWSubscriptionPlanCardType.SKINNY ? 3 : 4,
            onLearnMoreClick: onLearnMoreClick,
            showFullText: noShadow,
            isPreview: isPreview
          })
        }), type === TWSubscriptionPlanCardType.FULL_WIDTH && plan.who_is_it_for && /*#__PURE__*/_jsxs("div", {
          className: "my-8",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex items-center",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "m-0 flex-shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-gray-900",
              children: "Perfect for"
            }), /*#__PURE__*/_jsx("div", {
              className: "flex-1 border border-l-0 border-r-0 border-b-0 border-t-2 border-gray-200"
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-4",
            children: plan.who_is_it_for
          })]
        }), type === TWSubscriptionPlanCardType.FULL_WIDTH && sortedFeatures && /*#__PURE__*/_jsx("div", {
          className: "",
          children: renderFeatures()
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames('flex flex-col my-auto', {
          'px-6 pb-8': type === TWSubscriptionPlanCardType.SKINNY,
          'p-12 w-priceContainer items-center': type === TWSubscriptionPlanCardType.FULL_WIDTH
        }),
        children: [PriceAndButton, type === TWSubscriptionPlanCardType.FULL_WIDTH && plan.trial_period_days > 0 && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx("div", {
            className: "pt-8 text-gray-500 leading-6",
            children: TrialText
          })
        })]
      }), type === TWSubscriptionPlanCardType.SKINNY && /*#__PURE__*/_jsxs(_Fragment, {
        children: [plan.trial_period_days > 0 && !subscribedToService && /*#__PURE__*/_jsx("div", {
          className: "px-6 pb-4 text-gray-500 leading-6",
          children: TrialText
        }), (sortedFeatures || isPreview) && /*#__PURE__*/_jsxs("div", {
          className: "pt-2 pb-8 px-6",
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex-1 border border-l-0 border-r-0 border-b-0 border-t-2 border-gray-200"
          }), ((plan === null || plan === void 0 ? void 0 : plan.who_is_it_for) || isPreview) && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("p", {
              className: classNames('m-0 mt-6 pr-4 bg-white text-sm font-semibold uppercase text-base'),
              children: "perfect for"
            }), /*#__PURE__*/_jsx("p", {
              className: classNames('text-sm text-base', {
                'text-gray-500': isPreview
              }),
              children: (plan === null || plan === void 0 ? void 0 : plan.who_is_it_for) || 'Description goes here'
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "",
            children: renderFeatures()
          })]
        })]
      })]
    })]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.auth.users.current,
    userSubscriptions: Object.values(state.subscriptions.subscriptions),
    planProspects: Object.values(state.provider.planProspects),
    loading: state.provider.loading
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TWSubscriptionPlan);
TWSubscriptionPlan.defaultProps = {
  ctaText: 'Subscribe',
  noShadow: false
};